import React, { Component } from 'react';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import FigmaButton from '../../../Elements/FigmaButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import ApplicablePaymentItem from '../../../Domain/ApplicablePaymentItem';

export default class ApplyPaymentPanel extends Component {
  static defaultProps = {
    baseItem: {},
    refresh: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      saving: false,
      searchItem: this.props.baseItem.ClientInvoiceId,
    };

    ApplicablePaymentItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.CpId === item.CpId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });

    const item = this.props.baseItem;
    item.ClientPaymentId = this.state.itemList.find((f) => f.Selected).CpId;

    ClientPaymentService.ApplyPayment(item)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ saving: false });
          return;
        }
        ErrorMessage.SetNotification('Payment applied.');
        this.props.refresh(true);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: CPP42. Payment application failed. Please notify IT!');
        this.setState({ saving: false });
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Apply Payment'
          submit={true}
          iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={() => this.handleOnSubmit()}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        title={'Choose Client Payment To Apply'}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.refresh(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        zIndex={1050}
        className='applySurveyPanel top-of-boxFigma'
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>
          <TabOfDataTable
            itemList={this.state.itemList}
            type={ApplicablePaymentItem}
            serviceFunction={ClientPaymentService.GetApplicablePayments}
            changeOfItemListFunction={(itemList) => this.setState({ itemList })}
            convertDBItemsFunction={ClientPaymentService.ConvertApplicablePaymentDBItems}
            enableUrlPush={false}
            searchItem={this.state.searchItem}
            orderBy='CpPaymentDate'
            orderDirection='Desc'
          />
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
